import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { makeStyles, styled } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";
import TablePaginationActions from "./TablePaginationActions";
import TableDropwdownActions from "./TableDropwdownActions";

const useStyles = makeStyles(() => ({
  tableHead: {
    backgroundColor: "#f5f2e6",
  },
  actionButtonDelete: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    borderRadius: "5px",
    marginRight: "10px",
    cursor: "pointer",
    "&:hover": {
      background: "#ba2941",
      color: "white",
    },
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    borderRadius: "5px",
    marginRight: "10px",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
      color: "white",
    },
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#499178",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "#f0faf6",
    cursor: "pointer",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#f0faf6",
    },
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CustomTable({
  column,
  data,
  listData,
  actions,
  handleEditData,
  deleteClassItem,
  deleteTemporary,
  activeClassItem,
  page,
  rowsPerPage,
  handleViewData,
  handleChangePage,
  handleChangeRowsPerPage,
}) {
  const styles = useStyles();

  return (
    <Paper
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "column",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead className={styles.tableHead}>
            <StyledTableRow>
              {column.length > 0 &&
                column.map((item, index) => (
                  <StyledTableCell align="center" key={index}>
                    {item}
                  </StyledTableCell>
                ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {data.docs.length > 0 ? (
              data.docs.map((row, index) => (
                <StyledTableRow
                  key={index}
                >
                  {listData.map((item, index) => {
                    return (
                      <StyledTableCell
                        style={{ width: 160 }}
                        align="center"
                        key={index}
                      >
                        {row[item] ? row[item] : "-"}
                      </StyledTableCell>
                    );
                  })}
                  {actions ? (
                    <StyledTableCell style={{ width: 170 }} align="center">
                      <TableDropwdownActions
                          handleEditData={() => handleEditData(row._id)}
                          handleDetailData={() => handleViewData(row._id)}
                          deleteClassItem={() => deleteClassItem(row._id)}
                          deleteItem={() => deleteTemporary(row._id)}
                          activeClassItem={() => activeClassItem(row._id)}
                          styles={styles}
                          row={row}
                        />
                    </StyledTableCell>
                  ) : (
                    ""
                  )}
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell style={{ width: "100%" }} align="center">
                  Tidak ada data
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {data.docs.length > 0 ? (
        <TablePagination
          rowsPerPageOptions={""}
          rowsPerPage={rowsPerPage}
          colSpan={12}
          count={data.totalDocs}
          page={page}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          sx={{ width: "100%" }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      ) : (
        ""
      )}
    </Paper>
  );
}

CustomTable.propTypes = {
  column: PropTypes.array,
  data: PropTypes.array,
  listData: PropTypes.array,
  actions: PropTypes.bool,
  handleEditData: PropTypes.func,
  deleteClassItem: PropTypes.func,
  deleteTemporary: PropTypes.func,
  activeClassItem: PropTypes.func,
  handleViewData: PropTypes.func,
  page: PropTypes.string,
  rowsPerPage: PropTypes.string,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
};
